import {useAbTestExperimentsCookie} from '@aboutyou/feature-flags';
import {trackABTestGroupAssignment} from '@aboutyou/legacy-tracking-sdk';
import {useEffect} from 'react';
import {useTracking} from '../utils/utils';

/**
 * This is the tracking hook to track AB test group assignment.
 *
 * This implementation is an interim solution until full tracking is not implemented in the @aboutyou/legacy-tracking-sdk.
 *
 * This hook performs 1 action:
 * - sends the tracking event to the @aboutyou/legacy-tracking-sdk using {@link trackABTestGroupAssignment}
 *
 * This hook would send the data layer event only if {@link AB_TEST_COOKIES.Experiments} is present and valid.
 *
 * @version 1.
 * @deprecated. the {@link trackABTestGroupAssignment} shouldn't be used without tracking client
 */
export const useTrackAbTest = () => {
  const {TrackingClient} = useTracking();
  const abTestExperiments = useAbTestExperimentsCookie();

  useEffect(() => {
    abTestExperiments.forEach(abTestExperiment => {
      TrackingClient.track(
        trackABTestGroupAssignment({
          testName: abTestExperiment.key,
          testVariation: abTestExperiment.group,
        }),
      );
    });
  }, [TrackingClient]);
};
